import { memo, useEffect } from 'react';
import { createPortal } from 'react-dom';
import useModalEnter from '../../hooks/useModalEnter';

const CasinoRulesModal = memo(function CasinoRulesModal({
  show,
  onClose,
  tableClass = '',
  gameType = '',
  children,
}) {
  const isLottery = gameType === 'lottcard';
  // Lottery uses full modal on all screens; others only on mobile
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const shouldShow = isLottery ? show : (show && isMobile);

  useEffect(() => {
    if (shouldShow) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => document.body.classList.remove('modal-open');
  }, [shouldShow]);

  // Open animation + outside click: hooks/useModalEnter
  const { entered, backdropClass, onBackdropClick } = useModalEnter(onClose, shouldShow);

  if (!shouldShow) return null;

  const showCls = entered ? ' show' : '';
  const modalClass = isLottery
    ? `modal fade${showCls} casino-rules lottery-rules`
    : `modal fade${showCls} casino-rules teenpatti2-rule-modal${tableClass ? ` ${tableClass}-rule-modal` : ''}`;

  return createPortal(
    <div id="rules-modal___BV_modal_outer_" style={{ position: 'absolute', zIndex: 1040 }}>
      <div
        id="rules-modal"
        role="dialog"
        aria-labelledby="rules-modal___BV_modal_title_"
        aria-describedby="rules-modal___BV_modal_body_"
        className={modalClass}
        aria-modal="true"
        style={{ display: 'block' }}
        onClick={onBackdropClick}
      >
        <div className={`modal-dialog ${isLottery ? 'modal-lg' : 'modal-md'}`} onClick={(e) => e.stopPropagation()}>
          <span tabIndex="0"></span>
          <div id="rules-modal___BV_modal_content_" tabIndex="-1" className="modal-content">
            <header id="rules-modal___BV_modal_header_" className="modal-header">
              <h5 id="rules-modal___BV_modal_title_" className="modal-title">Rules</h5>
              <button type="button" aria-label="Close" className="close" onClick={onClose}>
                &times;
              </button>
            </header>
            <div id="rules-modal___BV_modal_body_" className="modal-body">
              {isLottery ? children : (
                <div className="casino-vieo-rules show-rules show">
                  <div className="rules-body">
                    {children}
                  </div>
                </div>
              )}
            </div>
          </div>
          <span tabIndex="0"></span>
        </div>
      </div>
      <div id="rules-modal___BV_modal_backdrop_" className={backdropClass}></div>
    </div>,
    document.body
  );
});

export default CasinoRulesModal;
